import React from "react";

const CancelledLogo = () => {
  return (
    <div
      class="absolute w-max h-max uppercase z-50
             top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
             rotate-[345deg] text-[80px] font-extrabold text-[#ff1e00]"
    >
      CANCELLED
    </div>
  );
};

export default CancelledLogo;
